export default "__VITE_ASSET__bbae1af3__"